// extracted by mini-css-extract-plugin
module.exports = {"title":"termsInstrictionInner_title__mWB6W","hide":"termsInstrictionInner_hide__wM_Nt"};